<template>
  <div class="component-container">
    <div class="second-edition" id="second-edition">
      <h3>1PNG Second Edition - Waves: Light and Sound - Downloads and Resources</h3>
      <div class="back-button-wrapper">
        <button type="button" @click.prevent="cancelButton" class="back-button">Back to Main Dashboard</button>
      </div>
      <div class="presentations">
        <h4>Teacher Resources</h4>
        <ul>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-online-prototype.appspot.com/o/activityPresentations%2FAugust%202024%20Updates%2F1PNG-2E_Activities_1-6_08212024.zip?alt=media&token=b13f0bc9-ec0e-4eea-9248-945619aac947" target="_blank">Teacher Presentations: Activities 1 - 6</a> - Updated 8/21/2024</li>
          <li><a href="https://docs.google.com/spreadsheets/d/1RZrQWEcgAu2kxE60cdaDCwpFOj35RFvl_ZiPRYWxAXw/edit?usp=sharing" target="_blank">Teacher Guide Links Spreadsheet</a> - List of all links in the printed Teacher Guide</li>
          <li><a href="https://docs.google.com/spreadsheets/d/1qe8R8GD92WO6dtzWri9pKbKWjAYx2siuRzdE8bcT_6c/edit?gid=1062009112#gid=1062009112">Curriculum Updates Spreadsheet </a> - List with links to updates for your printed Teacher Guide</li>
        </ul>
      </div>
      <div class="presentations">
        <h4>Student Journals &amp; Assessments</h4>
        <p>Please make a master copy for your classroom and save to your Google drive for your classroom.</p>
        <ul>
          <li><a href="https://docs.google.com/presentation/d/1e3og6hwri62lrEx9csvSvE1PYlIn7YA4dzkIyZ5x9FM/copy" target="_blank">1PNG Second Edition - Waves: Light and Sound Student Journal</a></li>
          <li><a href="https://drive.google.com/file/d/1_no1OVuEQpaqJBQAWAjKZtqZXTpcGSps/view" target="_blank">1PNG Second Edition -  Waves: Light and Sound Student Journal Answer Key</a></li>
          <li><a href="https://docs.google.com/presentation/d/1uG8HWUg8u7qNj2l0x6d5uJfSwzGSpaXRmglnFXyHBLk/copy" target="_blank">1PNG Second Edition -  Waves: Light and Sound Student Journal - SPANISH</a></li>
        </ul>
        <ul>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-dev-926a6.appspot.com/o/unitUpdates%2F1PNG-2E_PostAssessment_12062021.pdf?alt=media&token=934143e0-3ba6-46c0-bde0-ae4e1aeef1f5" target="_blank">1PNG Second Edition Post Assessment - Updated 5/31/2022</a></li>
          <li><a href="https://console.firebase.google.com/u/2/project/ccs-dev-926a6/firestore/data/~2FcurriculumUpdates~2F94C0vYK4UwOCAxSrPS9K" target="_blank">1PNG Second Edition Post Assessment (Spanish) - Updated 5/31/2022</a></li>
        </ul>
      </div>
  <div class="presentations">
        <h4>Individual Resources</h4>
        <p>The resources below are also linked in the Teacher Led Presentations. We've provided them here for anyone wishing to have access to these individual resources outside of the presentations. Please make master copies and save in your Google drive for your classroom.</p>
        <h4 style="margin-left: 10px;">Charts, Handouts, Card Sets, etc.</h4>
        <ul>
          <li><a href="https://docs.google.com/presentation/d/1vfmkTY9_f6_YRhOHwd-OkFm4iFTxEtS4jwcJhv1flxI/copy" target="_blank">What We Think Chart</a></li>
          <li><a href="https://docs.google.com/presentation/d/11X_NTXJH0PP52vCilCXYHU2ZyypN5MOiBMh-hM_RmIk/copy" target="_blank">1PNG Word Wall</a></li>
          <li><a href="https://docs.google.com/presentation/d/1wALPWdQIf_YGBl9XKZbZ3hbvKaF1YpyIDsZH_1O-KPo/copy" target="_blank">Light Interactions Card Set</a></li>
          <li><a href="https://docs.google.com/presentation/d/1sUusTDgBTEbdTUtuKZH4TynEq6kLpWYX12u00XUoFm4/copy" target="_blank">Word Sort Cards - Lesson 3A</a></li>
          <li><a href="https://docs.google.com/presentation/d/1eyAk9jW_ho33SBEb68PbleLGUAXNSjesdVhHfwEeaVQ/copy" target="_blank">Word Sort Cards - Lesson 3C</a></li>
          <li><a href="https://docs.google.com/presentation/d/1N4jS8aI8OwIm8LXPJ-eOsLplm4zP-x3iYNklUXnIL-w/copy" target="_blank">Word Sort Cards - Lesson 3D</a></li>
          <!-- <li><a href="" target="_blank"></a></li> -->

        </ul>
        <h4 style="margin-left: 10px;">Demonstration Videos</h4>
        <ul>
          <li><a href="https://drive.google.com/file/d/1krfIY4JNVKzVU2QtY2W8Ik085ipmue2Q/view?usp=sharing" target="_blank">1PNG-2E Lesson 1B: Video of Light in a Box</a></li>
          <li><a href="https://drive.google.com/file/d/1_pUToms3uFim7o8PKbxuwlbBgTsWaCIK/view?usp=sharing" target="_blank">1PNG-2E Lesson 2A: Lightbox Investigation</a></li>
          <li><a href="https://drive.google.com/file/d/1Q3iFyhdDeQXf4k14F665FYcHX_etIeP6/view?usp=sharing" target="_blank">1PNG-2E Lesson 2B: Flashlight and Index Cards Investigation</a></li>
          <li><a href="https://drive.google.com/file/d/1Jk0j3t_86g1sMKzl0QZ1RdDDGvkUJy_s/view?usp=sharing" target="_blank">1PNG-2E Lesson 2C: Light Interacting with Different Materials</a></li>
          <li><a href="https://youtu.be/3B7KLstUZbI" target="_blank">1PNG-2E Lesson 3C: Video of Morning, Noon, and Afternoon Shadows</a></li>
          <li><a href="https://drive.google.com/file/d/1ICaXzS2Rq80t0ROpDjiE_4gv6U-BjSI0/view?usp=sharing" target="_blank">1PNG-2E Lesson 4A: Salt Bouncing on Balloon</a></li>
          <li><a href="https://jamboard.google.com/d/1lBA770I4lb3KMcnQRDCop9Al8NuOJ1MRySyOZEQyavk/copy" target="_blank">1PNG-2E Lesson 4B: Station 1</a></li>
          <li><a href="https://drive.google.com/file/d/1PQ8Wrs7eTZtYihOOikjPATx-1WvM2Tjo/view?usp=sharing" target="_blank">1PNG-2E Lesson 4B: Station 2</a></li>
          <li><a href="https://www.youtube.com/watch?v=JoVOWNmwcOI" target="_blank">1PNG-2E Lesson 4B: Station 3</a></li>
          <li><a href="https://www.pbslearningmedia.org/resource/phy03.sci.phys.howmove.collage/understanding-vibration-and-pitch/" target="_blank">1PNG-2E Lesson 4B: Station 4</a></li>
          <li><a href="https://drive.google.com/file/d/1UVe_lKQCZqhNQdLiejGtvOKWKgMmZFYk/view?usp=sharing" target="_blank">1PNG-2E Lesson 4B: Station 5</a></li>
          <li><a href="https://drive.google.com/file/d/1eRcrNZ-yvedJejK6hBxYVTT9-Kbfdr4N/view?usp=sharing" target="_blank">1PNG-2E Lesson 4B: Station 6</a></li>
          <li><a href="https://drive.google.com/file/d/1d_joguuzi0ecp1PC-2dQmHeqLZ4aHvaJ/view" target="_blank">1PNG-2E Lesson 4C: Tuning Fork in Water</a></li>
          <li><a href="https://drive.google.com/file/d/1CZ_zKHcLPo9mMuQw06KvG60lXQrStfD7/view" target="_blank">1PNG-2E Lesson 4C: Tuning Fork Touching Pie Pan</a></li>
          <li><a href="https://www.youtube.com/watch?v=_wHx_tBfu5c" target="_blank">1PNG-2E Lesson 5A: Video of Plastic Ruler</a></li>
          <li><a href="https://www.youtube.com/watch?v=dDshiu5um9g" target="_blank">1PNG-2E Lesson 5A: Video of Metal Ruler</a></li>
          <li><a href="https://www.youtube.com/watch?v=3AIEGAgzbTI" target="_blank">1PNG-2E Lesson 5A: Dolphins Under Water</a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {}
  },
  computed: {
    ...mapState([ 'dashboardView', 'userProfile' ])
  },
  methods: {
    cancelButton() {
      this.$store.commit('SET_DASHBOARD_VIEW', 'units')
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  }
}
</script>

<style lang="css" scoped>
.presentations {
  border: 1px solid grey;
  text-align: left;
  padding: 20px;
  margin: 0 20px 20px 20px;
}
ul {
  list-style: none;
}
.presentations a {
  margin-left: 40px;
}
li {
  margin-left: -40px;
}
.back-button-wrapper {
  width: 100%;
  text-align: left;
  margin-bottom: 0;
}
.back-button {
  background: white;
  border: none;
  font-weight: 600;
  color: #7b8a1d;
  margin-left: 20px;
}
</style>
